import { useState } from 'react'

import type {
  UsersAccessFilterCountsI,
  UsersAccessFilterValuesI,
} from '../../types/usersAccess'
import { getUsersAccessFilterCount } from '../../utils/usersAccess'
import { useTranslation } from 'react-i18next'

import {
  BadgeCounter,
  Box,
  FilterIcon,
  IconButton,
  TableToolbar,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { UsersAccessFilterDrawer } from './UsersAccessFilterDrawer'

interface UsersAccessToolbarIProps {
  colorScheme: ColorScheme
  counts: UsersAccessFilterCountsI
  filters: UsersAccessFilterValuesI
  onApplyFilters: (filters: UsersAccessFilterValuesI) => void
  onSearchChange: (value: string) => void
  search: string
}

export const UsersAccessToolbar = ({
  colorScheme,
  counts,
  filters,
  onApplyFilters,
  onSearchChange,
  search,
}: UsersAccessToolbarIProps) => {
  const { t } = useTranslation()
  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false)
  const filterCount = getUsersAccessFilterCount(filters)

  return (
    <>
      <TableToolbar
        actions={
          <Box alignItems='center' display='flex' gap='8px'>
            {filterCount > 0 && (
              <BadgeCounter
                colorScheme={colorScheme}
                count={filterCount}
                variant='button'
              />
            )}
            <IconButton
              aria-label={t('settings:rebrand_users_filter_button')}
              colorScheme={colorScheme}
              data-testid='usersAccess_filterButton'
              dimension={36}
              icon={<FilterIcon colorScheme={colorScheme} />}
              onClick={() => setIsFilterDrawerOpen(true)}
            />
          </Box>
        }
        colorScheme={colorScheme}
        onChange={onSearchChange}
        placeholder={t('settings:rebrand_users_search_placeholder')}
        value={search}
      />
      <UsersAccessFilterDrawer
        colorScheme={colorScheme}
        counts={counts}
        filters={filters}
        isOpen={isFilterDrawerOpen}
        onApply={onApplyFilters}
        onClose={() => setIsFilterDrawerOpen(false)}
      />
    </>
  )
}
